import { FormConfigContext } from '@juvare/common-form-ui/FormConfigContext';
import { useCallback, useContext } from 'react';
/**
 * INFO: this hook provides helper functions for accessing professional statuses (from FormConfigContext)
 **/
export function useProfessionalStatuses() {
    const { formParams } = useContext(FormConfigContext);
    const getProfessionalStatusById = useCallback((id) => {
        var _a;
        if (!id || !((_a = formParams === null || formParams === void 0 ? void 0 : formParams.professionalStatuses) === null || _a === void 0 ? void 0 : _a.length)) {
            return undefined;
        }
        return formParams === null || formParams === void 0 ? void 0 : formParams.professionalStatuses.find((professionalStatus) => professionalStatus.value === id);
    }, [formParams === null || formParams === void 0 ? void 0 : formParams.professionalStatuses]);
    const getProfessionalStatusValueById = useCallback(function (id, key) {
        const status = getProfessionalStatusById(id);
        return status ? status[key] : undefined;
    }, [getProfessionalStatusById]);
    return {
        professionalStatusCredentialId: formParams === null || formParams === void 0 ? void 0 : formParams.professionalStatusCredentialId,
        professionalStatuses: formParams === null || formParams === void 0 ? void 0 : formParams.professionalStatuses,
        getProfessionalStatusById,
        getProfessionalStatusValueById,
    };
}
